import { memo, useMemo } from 'react';
import MathText from '../MathText';

/**
 * Rendu preview/élève d'une question "Classer".
 * Affiche les éléments mélangés en haut + les catégories vides en dessous.
 *
 * @param {Array} categories - Les catégories [{ name, items }, ...]
 */
const ClasserRenderer = memo(function ClasserRenderer({ categories, light }) {
    // Mélanger tous les éléments de toutes les catégories
    const shuffledItems = useMemo(() => {
        if (!categories || categories.length === 0) return [];
        const all = categories.flatMap(c => c.items || []);
        const shuffled = [...all];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }, [categories]);

    if (!categories || categories.length === 0) return null;

    return (
        <div>
            {!light && <span className="text-[10px] font-semibold uppercase tracking-wider mb-2 block text-slate-400">Classer</span>}

            {/* Catégories vides (zones de dépôt) */}
            <div className="flex gap-3 mb-3">
                {categories.map((cat, i) => (
                    <div
                        key={i}
                        className={`flex-1 border-[1.5px] border-dashed rounded-xl p-3 text-center min-h-[80px] flex flex-col items-center justify-center gap-2 ${
                            light ? 'border-sky-300 bg-sky-50/50' : 'border-slate-500'
                        }`}
                    >
                        <span className={`text-xs font-semibold ${light ? 'text-sky-800' : 'text-slate-300'}`}><MathText>{cat.name}</MathText></span>
                        <span className={`text-[10px] ${light ? 'text-sky-400' : 'text-slate-500'}`}>Glisser ici</span>
                    </div>
                ))}
            </div>

            {/* Propositions mélangées en bas */}
            <div className="flex flex-wrap gap-2 justify-center">
                {shuffledItems.map((item, i) => (
                    <span
                        key={i}
                        className={`px-4 py-2 rounded-xl border text-sm transition-all shadow-sm ${
                            light
                                ? 'border-sky-200 bg-white text-sky-800 font-medium'
                                : 'border-slate-500 bg-slate-700 text-slate-200 cursor-pointer hover:bg-slate-600 hover:border-slate-400'
                        }`}
                    >
                        <MathText>{item}</MathText>
                    </span>
                ))}
            </div>
        </div>
    );
});

export default ClasserRenderer;
